import { render, staticRenderFns } from "./ClientFormModal.vue?vue&type=template&id=4add5911&scoped=true"
import script from "./ClientFormModal.vue?vue&type=script&lang=js"
export * from "./ClientFormModal.vue?vue&type=script&lang=js"
import style0 from "./ClientFormModal.vue?vue&type=style&index=0&id=4add5911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add5911",
  null
  
)

export default component.exports